/**
 * Locale-aware currency formatting backed by Intl.NumberFormat.
 *
 * All 8 NettleWorth locales map to USD (data is US-based).
 * FX conversion can be layered on top later if Will wants it —
 * just update LOCALE_CURRENCY and pass currency overrides.
 */

export const LOCALE_CURRENCY = {
  'en-US': 'USD',
  'en-GB': 'USD',
  'en-AU': 'USD',
  'en-CA': 'USD',
  'es-ES': 'USD',
  'fr-FR': 'USD',
  'de-DE': 'USD',
  'zh-Hans': 'USD',
};

/** Cache keyed by "locale|currency|fractionDigits" */
const fmtCache = new Map();

/**
 * Format a numeric amount as a currency string using Intl.NumberFormat.
 *
 * @param {number} amount
 * @param {string} locale - BCP 47 locale code
 * @param {object} [options]
 * @param {string} [options.currency] - ISO 4217 currency code (default: LOCALE_CURRENCY[locale] ?? 'USD')
 * @param {number} [options.maximumFractionDigits] - decimal places (default: 0)
 * @returns {string}
 */
export function formatCurrency(amount, locale, options = {}) {
  const currency = options.currency ?? LOCALE_CURRENCY[locale] ?? 'USD';
  const maximumFractionDigits = options.maximumFractionDigits ?? 0;

  const cacheKey = `${locale}|${currency}|${maximumFractionDigits}`;
  let fmt = fmtCache.get(cacheKey);
  if (!fmt) {
    fmt = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      maximumFractionDigits,
      minimumFractionDigits: maximumFractionDigits,
    });
    fmtCache.set(cacheKey, fmt);
  }
  return fmt.format(amount);
}
